const extractStringMessage = (args: unknown[]): string => {
    return args
        .map((x) => {
            if (['string', 'number', 'boolean'].includes(typeof x)) {
                return x
            }
            if (x instanceof Element) {
                return `${x.tagName}.${x.className}`
            }
            if (typeof x === 'object' && x) {
                const ctr = x.constructor.name
                return `[${ctr}]${JSON.stringify(x).slice(0, 20)}`
            }
            if (typeof x === 'symbol') {
                return x.toString()
            }
            return undefined
        })
        .join(' ')
}

let handling = false
/* oxlint-disable no-console */
export const installVueConsoleHandlers = (onMessage: (type: 'warn' | 'error', msg: string) => void) => {
    const originalConsoleWarn = console.warn
    console.warn = (...args) => {
        if (typeof args[0] === 'string' && args[0].startsWith('[Vue ') && !handling) {
            handling = true
            try {
                onMessage('warn', extractStringMessage(args))
            } catch {}
            handling = false
        }
        originalConsoleWarn(...args)
    }
    const originalConsoleError = console.error
    console.error = (...args) => {
        if (typeof args[0] === 'string' && args[0].startsWith('[Vue ') && !handling) {
            handling = true
            try {
                onMessage('error', extractStringMessage(args))
            } catch {}
            handling = false
        }
        originalConsoleError(...args)
    }
}
